<template>
  <div class="container">
    <!-- <div class="logo"></div> -->
    <div class="red-packet">
      <h2>早晚读书会</h2>
      <ul>
        <li>
          <div class="side">年度会员（365天）</div>
          <div class="aside">¥ {{ticketInfo.mbrCouponsModel.presentPrice}}</div>
        </li>
        <li>
          <div class="side">红包</div>
          <div class="aside arr" @click="showPocketFn">{{status}}</div>
        </li>
        <li>
          <div class="side">合计</div>
          <div class="aside">¥ {{total}}</div>
        </li>
      </ul>
      <input type="button" value="确认支付" @click="payFn" class="btn">
      <div class="desc-box">
        <div class="desc">购买说明：</div>
        <p>1、支付成功后将获得会员激活码，激活码有效2020年5月，待读书会产品上线后，在此之前的任意时间都可以选择激活，从激活后的第二个自然日开始计算会员时长，为期1年（365天）。</p>
        <p>2、会员卡属于虚拟产品，暂不支持退换，请您理解。</p>
      </div>
    </div>
    <packetbox :isShow="isShow" @closeFn="closeFn">
      <p class="box-title">我的红包</p>
      <ul v-if="ticketInfo.lvo.length ">
        <li
        v-for="(item, index) in ticketInfo.lvo"
        :key="index"
        @click="selectPocket(item)"
        >
          <p class="name">{{item.shareName}}</p>
          <p class="number">
            <span>{{item.denomination}}元代金券</span>
            <span class="radio" :class="item.redId === ticketId ? 'on' : ''"></span>
          </p>
        </li>
      </ul>
      <div v-else class="empty">没有红包了~</div>
    </packetbox>
    <div class="mask" @click="closeFn(false)" v-show="isShow"></div>
  </div>
</template>

<script>
import $ from "jquery"
import Packetbox from "@/components/packet-box";
import wx from "weixin-js-sdk"
export default {
  name: "memberpay",
  data() {
    return {
      isShow: false,
      ticketId: '', // 选择优惠券的id
      pocketMoney: 0, // 红包价钱
      item: '',
      ticketInfo: {
        lvo: [{
          shareName: ''
        }],
        mbrCouponsModel: {},
        payMap: []
      }, // 优惠券信息
      payResult: {}, // 支付完成信息
      shareUrl: ''
    };
  },
  computed: {
    total: function(){
      return this.ticketInfo.mbrCouponsModel.presentPrice - this.pocketMoney
    },
    status: function(){
      // return this.ticketId >=0 ? `${this.item.shareName} -¥ ${this.item.denomination}` : `有${this.ticketInfo.lvo.length}个可以使用`
      return Number(this.ticketId) > 0 ? `${this.item.shareName} -¥ ${this.item.denomination}` : `有${this.ticketInfo.lvo.length}个可以使用`
    }
  },
  created() {
    this.$loading.show({
      el: this.$refs.loading
    })
    this.axiosPost("v/mbrCoupons/buyMbrCouponsPage", {
      token: localStorage.getItem('token'),
      uid: localStorage.getItem('uid')
    }) // 支付卡卷模板
    .then(res => {
      if (res.data.attachment) {
        this.ticketInfo = res.data.attachment
        this.$loading.hide()
      }
    })
    // 分享
    this.shareUrl = `${window.location.protocol}//${window.location.host}/index`
    let isUa = navigator.userAgent.toLowerCase().indexOf("android ") === -1 ? window.location.href : window.location.href 
    if(sessionStorage.getItem('tempUrl')){
      isUa = sessionStorage.getItem('tempUrl')
      sessionStorage.clear()
    }
    this.getShareInfo(isUa)
  },
  methods: {
    getShareInfo(url) {
      let that = this

      this.axiosPost("act/toShare", {
        // 通过分享接口获取分享url
        appUrl: window.location.href,
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid')
      }).then(res => {
        this.$loading.hide();
        this.wechatShare = res.data.attachment.wechatShare

        this.axiosPost("wechat/jsconfig", {
          // 微信jsapi-config参数获取
          appUrl: url
        }).then(result => {
          this.$loading.hide();
          let infoTotal = result.data.attachment;
          wx.config({
            debug: false,
            appId: infoTotal.appId,
            timestamp: infoTotal.timestamp,
            nonceStr: infoTotal.nonceStr,
            signature: infoTotal.signature,
            jsApiList: [
            "chooseImage",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ"
              // 所有要调用的 API 都要加到这个列表中
            ]
          })
          wx.ready( () => {
            //分享给好友
            wx.onMenuShareAppMessage({
              title: that.wechatShare.title, // 分享标题
              desc: that.wechatShare.desc, // 分享描述
              link: that.wechatShare.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！', // 分享标题
              // desc: '手快有，手慢无！', // 分享描述
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png', // 自定义图标
              type: "link", // 分享类型,music、video或link，不填默认为link
              dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                console.log(window.wechatInfo.title)
                // 用户确认分享后执行的回调函数
              },
              cancel: function() {
                // 用户取消分享后执行的回调函数
              }
            })

            //分享朋友圈
            wx.onMenuShareTimeline({
              title: that.wechatShare.title,
              link: that.wechatShare.link,
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！',
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ',
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png',// 自定义图标
              trigger: function(res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回.
                //alert('click shared');
              },
              success: function(res) {
                //alert('shared success');
                //some thing you should do
              },
              cancel: function(res) {
                //alert('shared cancle');
              },
              fail: function(res) {
                //alert(JSON.stringify(res));
              }
            })
          })
          wx.error(function(res) {
            if(sessionStorage.getItem('tempUrl')){
              return
            }
            sessionStorage.setItem('tempUrl', window.location.href)
            // window.location.reload()
          })
        })
      })
    },
    payFn() {
      if (this.ticketInfo.lvo.length>0 && Number(this.ticketId)<1){
        //弹出红包列表
        this.isShow = true
        return
      }
      this.$loading.show({
        el: this.$refs.loading
      });
      this.axiosPost("v/mbrCoupons/buyMbrCoupons", {
        // 支付
        modelId: this.ticketInfo.mbrCouponsModel.modelId,
        payType: "wechatH5pay",
        payMoney: 0,
        cardId: this.ticketId,
        actId: 1,
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid'),
        result: this.GetQueryString('result')
      }).then(res => {
        this.$loading.hide()
        console.log(888, res.data.attachment)
        this.payResult = res.data.attachment
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        }else{
          this.onBridgeReady()
        }
      });
    },
    onBridgeReady () {
      WeixinJSBridge.invoke(
      'getBrandWCPayRequest', this.payResult,
      res => {
        if(res.err_msg == "get_brand_wcpay_request:ok" ){
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          this.$router.push({path: '/successbuy', query: this.$route.query})
        }
        if(res.err_msg == "get_brand_wcpay_request:cancel" ){ // 用户取消
          this.$toast({message: '用户取消支付'})
        }
        if(res.err_msg == "get_brand_wcpay_request:fail" ){ //支付失败
          this.$toast({message: '支付失败'})
        }
      });
    },
    GetQueryString (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2]); return ''
    },
    showPocketFn() {
      //弹出红包列表
      this.isShow = true
      // $('body').on('touchmove',function(event){event.preventDefault()})
      // console.log(111)
    },
    selectPocket(item){ // 选择优惠券
      this.ticketId = item.redId
      this.pocketMoney = item.denomination
      this.item = item
      this.isShow = false
    },
    closeFn(b){
      this.isShow = b
      // document.documentElement.style.overflow='auto';
      // console.log(222)
    }
  },
  components: {
    Packetbox
  }
};
</script>


<style lang="stylus" scoped>
.empty
  color #888
  font-size .3rem
  margin .5rem auto
  text-align center

.box-title{
  font-size .3rem
  color #333
  height .42rem
  line-height .42rem
}
.container {
  width: 100%;
  height: 100%;
  background: #77D5D7 url('/images/bg.png') no-repeat;
  background-size: 100% auto;
  padding: 1.3rem 0 0.5rem 0;
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;

  .logo {
    position: absolute;
    left: 0.4rem;
    top: 0.4rem;
    width: 2.76rem;
    height: 0.7rem;
    background: url('/images/logo.png') no-repeat;
    background-size: 100% auto;
  }

  .red-packet {
    background: #fff;
    width: 6.7rem;
    margin: 0rem auto;
    padding: 0.5rem 0.45rem;
    border-radius: 0.3rem;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;

    h2 {
      font-size: 0.42rem;
      color: #333;
      height: 0.59rem;
      line-height: 0.59rem;
    }

    ul {
      width: 100%;

      li {
        height: 1.27rem;
        width: 100%;
        border-bottom: 1px solid #F0F0F0;
        display: flex;
        justify-content: space-between;
        line-height: 0.42rem;
        font-size: 0.3rem;
        align-items: center;

        .side {
          color: #888;
        }

        .aside {
          color: #333;

          &.arr {
            color: #E71C34;
            position: relative;
            cursor: pointer;

            &::after {
              position: absolute;
              content: '';
              top: 50%;
              transform: translateY(-50%);
              background: url('/images/arrow.png') center right no-repeat;
              background-size: 100% auto;
              width: 0.22rem;
              height: 0.22rem;
            }
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }

    .btn {
      background: linear-gradient(135deg, rgba(255, 70, 70, 1) 0%, rgba(231, 27, 52, 1) 100%);
      border-radius: 0.2rem;
      margin: 0.5rem auto;
      width: 5.8rem;
      height: 0.98rem;
      border: none;
      font-size: 0.36rem;
      color: #fff;
    }

    .desc-box {
      margin: 0.2rem auto 0;
      align-self: flex-start;
      width: 5.3rem;
      color: #333;

      .desc {
        font-size: 0.3rem;
        height: 0.42rem;
        line-height: 0.42rem;
        margin: 0 0 0.3rem;
        text-align: left;
      }

      p {
        font-size: 0.24rem;
        line-height: 0.4rem;
        color: #888;
        margin: 0;
        width: 100%;
        text-align: left;
        height: auto;
      }
    }
  }
}

.mask {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
